import(/* webpackMode: "eager", webpackExports: ["HomePageClient"] */ "/app/apps/storefront/src/app/[locale]/(app)/home-page-client.tsx");
